import { Link } from 'react-router-dom';
import LoginOutlinedIcon from '@mui/icons-material/LoginOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import InsightsOutlinedIcon from '@mui/icons-material/InsightsOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import InventoryOutlinedIcon from '@mui/icons-material/InventoryOutlined';
import BrandLogo from '../components/BrandLogo';

function AuthChoicePage() {
  return (
    <main className="public-home auth-hero-page">
      <header className="public-nav auth-nav">
        <BrandLogo compact={false} />
        <nav className="public-nav-actions" aria-label="Homepage actions">
          <a className="public-nav-link" href="mailto:contact@barbellos.co.in">
            <EmailOutlinedIcon fontSize="small" />
            contact@barbellos.co.in
          </a>
          <a className="public-nav-link" href="https://wa.me/918320073487" target="_blank" rel="noreferrer">
            <WhatsAppIcon fontSize="small" />
            Talk to our team on WhatsApp
          </a>
          <Link className="btn-link btn-primary-action public-login-btn" to="/login">
            <LoginOutlinedIcon fontSize="small" />
            Partner Login
          </Link>
        </nav>
      </header>

      <section className="public-hero auth-hero">
        <div className="public-hero-copy auth-hero-copy">
          <p className="eyebrow">Gym growth, billing, and member success in one workspace</p>
          <h1>BarbellOS for Gym Partners: Turn every outlet into a growth engine.</h1>
          <p className="public-lede">
            Manage partner onboarding, outlet operations, membership plans, payment reminders, overdue recovery,
            analytics, and member journeys with a single SaaS system built for modern fitness businesses.
          </p>
          <div className="public-hero-actions">
            <Link className="btn-link btn-primary-action" to="/login">
              <LoginOutlinedIcon fontSize="small" />
              Login to dashboard
            </Link>
            <a className="btn-link secondary" href="mailto:contact@barbellos.co.in">
              <EmailOutlinedIcon fontSize="small" />
              contact@barbellos.co.in
            </a>
            <a className="btn-link secondary" href="https://wa.me/918320073487" target="_blank" rel="noreferrer">
              <WhatsAppIcon fontSize="small" />
              WhatsApp us
            </a>
          </div>
        </div>

        <div className="public-product-panel auth-panel" aria-label="BarbellOS features overview">
          <div className="product-panel-top">
            <BrandLogo compact />
            <span>Designed for gym partners</span>
          </div>
          <div className="product-pill-grid">
            <div className="product-pill">Partner onboarding</div>
            <div className="product-pill">Outlet & plan management</div>
            <div className="product-pill">Member lifecycle</div>
            <div className="product-pill">Automated billing alerts</div>
            <div className="product-pill">Payment recovery</div>
            <div className="product-pill">Analytics dashboard</div>
          </div>
          <div className="product-list auth-panel-list">
            <p><span /> Smart partner and outlet hierarchy with user access controls</p>
            <p><span /> OTP-based onboarding, KYC document upload, and approval workflows</p>
            <p><span /> Billing subscriptions, dues tracking, invoices, holds, and QR payments</p>
            <p><span /> Automated email reminders, overdue notices, and cancellation workflows</p>
            <p><span /> Deep insights into collections, growth, plan uptake, and member retention</p>
          </div>
        </div>
      </section>

      <section className="public-feature-band auth-feature-band" aria-label="Application highlights">
        <article>
          <GroupsOutlinedIcon fontSize="small" />
          <h2>Partner Growth</h2>
          <p>Onboard partners and outlets quickly, then scale membership operations with data-driven controls.</p>
        </article>
        <article>
          <InventoryOutlinedIcon fontSize="small" />
          <h2>Membership Management</h2>
          <p>Complete member workflows from onboarding OTP to plan assignment, payment, and document submission.</p>
        </article>
        <article>
          <ReceiptLongOutlinedIcon fontSize="small" />
          <h2>Billing Automation</h2>
          <p>Collect dues, send email reminders, manage holds, and disable inactive members with one system.</p>
        </article>
        <article>
          <InsightsOutlinedIcon fontSize="small" />
          <h2>Operational Insights</h2>
          <p>Monitor overdue trends, subscription health, and outlet performance with easy reporting cards.</p>
        </article>
        <article>
          <ShieldOutlinedIcon fontSize="small" />
          <h2>Clean Compliance</h2>
          <p>Keep onboarding and verification workflows secure, with email OTP and partner approval flows.</p>
        </article>
      </section>

      <section className="public-contact-strip auth-contact-strip">
        <div>
          <p className="eyebrow">Ready to grow gym partnerships?</p>
          <h2>Talk to BarbellOS today.</h2>
          <p className="public-lede">Email us or chat on WhatsApp for a quick demo and pricing tailored to your fitness brand.</p>
        </div>
        <div className="contact-actions">
          <a className="btn-link btn-save" href="mailto:contact@barbellos.co.in">
            <EmailOutlinedIcon fontSize="small" />
            contact@barbellos.co.in
          </a>
          <a className="btn-link btn-save" href="https://wa.me/918320073487" target="_blank" rel="noreferrer">
            <WhatsAppIcon fontSize="small" />
          Contact Us on WhatsApp
          </a>
        </div>
      </section>
    </main>
  );
}

export default AuthChoicePage;
